var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHappyEmojiFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 39.375C31.8198 39.375 39.375 31.8198 39.375 22.5C39.375 13.1802 31.8198 5.625 22.5 5.625C13.1802 5.625 5.625 13.1802 5.625 22.5C5.625 31.8198 13.1802 39.375 22.5 39.375Z",
    fill: "#E9BE50",
    stroke: "#5F488A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1719 21.0938C17.3369 21.0938 18.2812 20.1494 18.2812 18.9844C18.2812 17.8194 17.3369 16.875 16.1719 16.875C15.0069 16.875 14.0625 17.8194 14.0625 18.9844C14.0625 20.1494 15.0069 21.0938 16.1719 21.0938Z",
    fill: "#5F488A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8281 21.0938C29.9931 21.0938 30.9375 20.1494 30.9375 18.9844C30.9375 17.8194 29.9931 16.875 28.8281 16.875C27.6631 16.875 26.7188 17.8194 26.7188 18.9844C26.7188 20.1494 27.6631 21.0938 28.8281 21.0938Z",
    fill: "#5F488A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8125 26.7188C29.0691 27.9995 28.0024 29.0625 26.7191 29.8015C25.4357 30.5404 23.9809 30.9293 22.5 30.9293C21.0191 30.9293 19.5643 30.5404 18.2809 29.8015C16.9976 29.0625 15.9309 27.9995 15.1875 26.7188",
    stroke: "#5F488A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyEmojiFilled);
export default __webpack_public_path__ + "static/media/happy-emoji-filled.65de57d5d3354b8ca5ab556b8f1f0a4f.svg";
export { ForwardRef as ReactComponent };